// **************************
// *** CardFotoServico | cardfotoservico.jsx 
// *** autor: Walcledson de Paula
// *** MVinfo Sistemas & Automação
// *** 24/12/24 | 12h14 | modificado para aceitar foto do serviço que está sendo criado/editado
// **************************






import { useState , useEffect} from 'react';
import Swal from 'sweetalert2';
import apiaxios from '../../../../Services/apiaxios';
import { decrypt } from '../../../../Services/cryptoUtils'
import { AutoLogout } from '../../../../Services/autologout';

import './p_cardfotoservico.css';

const CardFotoServico = ({ userId, servicoId, openDock, closeDock }) => {
    // console.log('CardFotoServico props: ', userId, servicoId);
    // const tokenASW = localStorage.getItem("tokenasw");
    const tokenASW = decrypt(localStorage.getItem('tokenasw'));
    useEffect(() => {
        const tokenlg = localStorage.getItem("tokenlg");
        
        if (!tokenASW || !tokenlg) {
            AutoLogout();
        }
    }, []);

    const [selectedFile, setSelectedFile] = useState(null);
    const [visibleButtons, setVisibleButtons] = useState(true);

    // const handleFileChange = (event) => {
    //     closeDock();
    //     const file = event.target.files[0];
    //     if (file) {
    //         const reader = new FileReader();
    //         reader.onloadend = () => {
    //             const base64Image = reader.result.split(',')[1]; // Remove o prefixo 'data:image/jpeg;base64,'
    //             setSelectedFile(base64Image);
    //             Swal.fire({
    //                 title: 'Confirmação',
    //                 text: 'Confirma esta foto/imagem?',
    //                 imageUrl: reader.result,
    //                 showCancelButton: true,
    //                 confirmButtonText: 'Sim, confirmo!',
    //                 cancelButtonText: 'Cancelar'
    //             }).then((result) => {
    //                 if (result.isConfirmed) {
    //                     handleUploadPhoto(base64Image);
    //                 }
    //             });
    //         };
    //         reader.readAsDataURL(file);
    //     }
    // };
    const handleFileChange = async (event) => {
        closeDock();
        const file = event.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onload = async (event) => {
            const originalImage = await resizeImage(event.target.result); // Redimensionamento assíncrono
            const base64Image = originalImage.split(',')[1]; // Remove o prefixo 'data:image/jpeg;base64,'
            setSelectedFile(base64Image);
            Swal.fire({
              title: 'Confirmação',
              text: 'Confirma esta foto/imagem?',
              imageUrl: originalImage, // Use a imagem redimensionada
              showCancelButton: true,
              confirmButtonText: 'Sim, confirmo!',
              cancelButtonText: 'Cancelar'
            }).then((result) => {
              if (result.isConfirmed) {
                handleUploadPhoto(base64Image);
              }
            });
          };
          reader.readAsDataURL(file);
        }
    };
      
    // Função de redimensionamento (exemplo)
    async function resizeImage(dataURL) {
        const MAX_WIDTH = 800; // Largura máxima desejada
        const MAX_HEIGHT = 600; // Altura máxima desejada
        const img = new Image();
        img.src = dataURL;
        await img.decode(); // Aguarda o carregamento da imagem
      
        const canvas = document.createElement('canvas');
        let width = img.width;
        let height = img.height;
      
        if (width > MAX_WIDTH) {
          height *= MAX_WIDTH / width;
          width = MAX_WIDTH;
        }
      
        if (height > MAX_HEIGHT) {
          width *= MAX_HEIGHT / height;
          height = MAX_HEIGHT;
        }
      
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);
      
        const resizedDataURL = canvas.toDataURL('image/jpeg', 0.7); // Qualidade da imagem (0 a 1)
        return resizedDataURL;
    }

    const handleUploadPhoto = async (base64Photo) => {
        // console.log('handleUploadPhoto', 'userId: ', userId, 'ServicoId: ', servicoId);
        try {
            const response = await apiaxios.put('/servico/TrocarFotoWeb', {
                id_usuario: userId, // Use o ID do usuário passado como prop
                id_servico: servicoId, // Use o ID do usuário passado como prop
                foto: base64Photo
            },
            {
                params: {
                    id_usuario: userId,
                    token: tokenASW
                }
            });

            if (response.status === 200 && response.data.retorno === 'OK') {
                Swal.fire('Sucesso', 'Foto salva com sucesso!', 'success');
            } else {
                Swal.fire('Erro', 'Falha ao salvar a foto. Tente novamente mais tarde.', 'error');
            }
        } catch (error) {
            Swal.fire('Erro', 'Falha ao salvar a foto. Tente novamente mais tarde.', 'error');
        }
        setVisibleButtons(false);
    };


    
    return (
        visibleButtons === true && (
            <div className="button-container">
                <br />
                <input
                    type="file"
                    accept="image/*"
                    capture="user"
                    onChange={handleFileChange}
                    style={{ display: 'none' }}
                    id="cameraInput"
                />
                <button className="btn btn-secondary btn-sm" onClick={() => document.getElementById('cameraInput').click()}>Câmera</button>

                <input
                    type="file"
                    accept="image/*"
                    onChange={handleFileChange}
                    style={{ display: 'none' }}
                    id="galleryInput"
                />
                <button className="btn btn-secondary btn-sm ml-10" onClick={() => document.getElementById('galleryInput').click()}>Galeria</button>
            </div>
        )
    );
};

export default CardFotoServico;
